/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.1
// source: proto/card.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.proto = require('./card_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CardServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CardServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CreateCardRequest,
 *   !proto.proto.CreateCardResponse>}
 */
const methodDescriptor_CardService_CreateCard = new grpc.web.MethodDescriptor(
  '/proto.CardService/CreateCard',
  grpc.web.MethodType.UNARY,
  proto.proto.CreateCardRequest,
  proto.proto.CreateCardResponse,
  /**
   * @param {!proto.proto.CreateCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateCardResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CreateCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardServiceClient.prototype.createCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardService/CreateCard',
      request,
      metadata || {},
      methodDescriptor_CardService_CreateCard,
      callback);
};


/**
 * @param {!proto.proto.CreateCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateCardResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardServicePromiseClient.prototype.createCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardService/CreateCard',
      request,
      metadata || {},
      methodDescriptor_CardService_CreateCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateCardRequest,
 *   !proto.proto.UpdateCardResponse>}
 */
const methodDescriptor_CardService_UpdateCard = new grpc.web.MethodDescriptor(
  '/proto.CardService/UpdateCard',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateCardRequest,
  proto.proto.UpdateCardResponse,
  /**
   * @param {!proto.proto.UpdateCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateCardResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardServiceClient.prototype.updateCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardService/UpdateCard',
      request,
      metadata || {},
      methodDescriptor_CardService_UpdateCard,
      callback);
};


/**
 * @param {!proto.proto.UpdateCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateCardResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardServicePromiseClient.prototype.updateCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardService/UpdateCard',
      request,
      metadata || {},
      methodDescriptor_CardService_UpdateCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeleteCardRequest,
 *   !proto.proto.DeleteCardResponse>}
 */
const methodDescriptor_CardService_DeleteCard = new grpc.web.MethodDescriptor(
  '/proto.CardService/DeleteCard',
  grpc.web.MethodType.UNARY,
  proto.proto.DeleteCardRequest,
  proto.proto.DeleteCardResponse,
  /**
   * @param {!proto.proto.DeleteCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeleteCardResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DeleteCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeleteCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeleteCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardServiceClient.prototype.deleteCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardService/DeleteCard',
      request,
      metadata || {},
      methodDescriptor_CardService_DeleteCard,
      callback);
};


/**
 * @param {!proto.proto.DeleteCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeleteCardResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardServicePromiseClient.prototype.deleteCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardService/DeleteCard',
      request,
      metadata || {},
      methodDescriptor_CardService_DeleteCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListCardRequest,
 *   !proto.proto.ListCardResponse>}
 */
const methodDescriptor_CardService_ListCard = new grpc.web.MethodDescriptor(
  '/proto.CardService/ListCard',
  grpc.web.MethodType.UNARY,
  proto.proto.ListCardRequest,
  proto.proto.ListCardResponse,
  /**
   * @param {!proto.proto.ListCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListCardResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardServiceClient.prototype.listCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardService/ListCard',
      request,
      metadata || {},
      methodDescriptor_CardService_ListCard,
      callback);
};


/**
 * @param {!proto.proto.ListCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListCardResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardServicePromiseClient.prototype.listCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardService/ListCard',
      request,
      metadata || {},
      methodDescriptor_CardService_ListCard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ItemCardRequest,
 *   !proto.proto.ItemCardResponse>}
 */
const methodDescriptor_CardService_ItemCard = new grpc.web.MethodDescriptor(
  '/proto.CardService/ItemCard',
  grpc.web.MethodType.UNARY,
  proto.proto.ItemCardRequest,
  proto.proto.ItemCardResponse,
  /**
   * @param {!proto.proto.ItemCardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ItemCardResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ItemCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ItemCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ItemCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CardServiceClient.prototype.itemCard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CardService/ItemCard',
      request,
      metadata || {},
      methodDescriptor_CardService_ItemCard,
      callback);
};


/**
 * @param {!proto.proto.ItemCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ItemCardResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CardServicePromiseClient.prototype.itemCard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CardService/ItemCard',
      request,
      metadata || {},
      methodDescriptor_CardService_ItemCard);
};


module.exports = proto.proto;

